import { render } from "./MembersRemovalUpload.vue?vue&type=template&id=6c4b3ef8"
import script from "./MembersRemovalUpload.vue?vue&type=script&lang=js"
export * from "./MembersRemovalUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__